import { ActionTypes } from "../contants/action-type";

const initialState = {
    cuisines: [],
    cuisine: {}
}

export const CuisineReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case ActionTypes.LIST_CUISINE:
            return {...state, cuisines: payload};
        case ActionTypes.SELECTED_CUISINE:
            return {...state, cuisine: payload};
        case ActionTypes.CONFIRM_CREATE_CUISINE:
            return {...state, cuisine: payload};
        case ActionTypes.CONFIRM_DELETE_CUISINE:
            return {...state, cuisines: payload};
        default:
            return state;
    }
}